import * as React from 'react';
import { observer } from 'mobx-react-lite';
import './eventReservationPane.module.scss';

import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { useEventReservationState } from './states/EventPaneState';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { ReservationPane, ReservationSubPanes } from '../../atoms/reservations/ReservationPane';
import { ReservationSummaryPane } from '../../molecules/reservations/ReservationSummaryPane';
import { ReservationActionPane } from '../../molecules/reservations/ReservationActionPane';
import { ReservationPaneHeader } from '../../atoms/reservations/ReservationPaneHeader';

type Props = {
  eventId: number;
};

export const EventReservation = observer((props: Props) => {
  const {
    submitting,
    event: eventResource,
    alreadyReserved,
    submit,
    setError,
  } = useEventReservationState(props.eventId);
  if (eventResource.isNotFound()) {
    return <NotFoundPage entityType="イベント" />;
  }
  if (eventResource.loading) {
    return <GlobalLoader />;
  }
  const event = eventResource.get();
  if (alreadyReserved) {
    setError('このイベントはすでに予約されています');
    return null;
  }
  return (
    <ReservationPane id="event-reservation-pane">
      <BackButton />
      <ReservationPaneHeader>予約内容の確認</ReservationPaneHeader>
      <ReservationSubPanes>
        <ReservationSummaryPane title={event.title} reservable={event} />
        <ReservationActionPane submitting={submitting} onSubmit={submit} />
      </ReservationSubPanes>
    </ReservationPane>
  );
});
